
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import { generateQuotationUrl, isValidQuotationCode } from "@/utils/quotation-utils";

interface CopyLinkButtonProps {
  quotation: any;
}

export function CopyLinkButton({ quotation }: CopyLinkButtonProps) {
  const { toast } = useToast();

  const copyToClipboard = async () => {
    try {
      console.log("Trying to copy quotation link, quotation:", quotation);
      
      // Ensure we have a valid code to generate the URL
      if (!quotation || !isValidQuotationCode(quotation.code)) {
        console.error('Quotation without valid code', quotation);
        toast({
          title: "Erro ao copiar",
          description: "Este orçamento não possui um código válido.",
          variant: "destructive",
        });
        return;
      }
      
      // Generate the full URL
      const url = generateQuotationUrl(quotation.code);
      console.log("Generated URL:", url);
      
      if (!url) {
        toast({
          title: "Erro ao copiar",
          description: "Não foi possível gerar o link do orçamento.",
          variant: "destructive",
        });
        return;
      }
      
      // Copy to clipboard
      await navigator.clipboard.writeText(url);
      
      toast({
        title: "Link copiado!",
        description: "O link do orçamento foi copiado para a área de transferência.",
      });
    } catch (err) {
      console.error('Error copying link:', err);
      toast({
        title: "Erro ao copiar",
        description: "Não foi possível copiar o link.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={copyToClipboard}
      className="hover:bg-[#0073B7] hover:text-white"
      title="Copiar link"
    >
      <Copy className="h-4 w-4" />
    </Button>
  );
}
